// extracted by mini-css-extract-plugin
export default {"result":"search-results_result__AOHQ7","icon":"search-results_icon__rL4BJ","time":"search-results_time__HGFt2","search":"search-results_search__xYAOO"};